import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { AuthRequiredPage } from "../pages/AuthRequiredPage";
import { isAdmin } from "../services/authService";

interface ProtectedRouteProps {
  children: ReactNode;
  feature: "portfolio" | "bookmarks" | "settings" | "brokerage" | "execution" | "admin" | "subscription" | "builder" | "optimizer" | "portfolio-lab";
}

/**
 * Wrapper component that shows the actual page content if authenticated,
 * or a nice "sign up to unlock" page if not authenticated.
 * For settings and admin, also checks for admin role.
 */
export function ProtectedRoute({ children, feature }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);

  if (!isAuthenticated) {
    return <AuthRequiredPage feature={feature} />;
  }

  // Settings and admin pages require admin role
  if ((feature === "settings" || feature === "admin") && !isAdmin(user)) {
    return <Navigate to="/search" replace />;
  }

  return <>{children}</>;
}
